// extracted by mini-css-extract-plugin
export default {"main":"UserInfoForm_main__jaNca","row":"UserInfoForm_row__PglX-","hlText":"UserInfoForm_hlText__LwvZD"};